const CONSTANTS = {
  PADDING_BOTTOM: '24px',
  PADDING_BETWEEN: '12px',
} as const;

export default CONSTANTS;
